import type { HelpArticle } from "../types";
import { calculatorReferenceArticles } from "./calculator-reference/calculatorReferenceArticles";
import { calculationGuideArticles } from "./calculations/workflowGuides";
import { creatingADesignProjectArticle } from "./getting-started/creating-a-design-project";
import { projectGuideArticles } from "./projects/projectGuides";
import { conceptGuideArticles } from "./reference/conceptGuides";
import { troubleshootingGuideArticles } from "./troubleshooting/troubleshootingGuides";

/** Fully authored records that fill the reserved IA slots in manifest.ts.
 * Keeping the manifest as the one ordered tree means public page navigation,
 * authenticated Help, contextual panels, and the generated search index all
 * expose the same inventory. */
export const authoredHelpArticles: Record<string, HelpArticle> = {
  [creatingADesignProjectArticle.id]: creatingADesignProjectArticle,
  ...calculationGuideArticles,
  ...projectGuideArticles,
  ...conceptGuideArticles,
  ...troubleshootingGuideArticles,
  ...calculatorReferenceArticles,
};
